import axios from 'axios';
import api from './api';

const API_BASE_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Interface pour un service dans un pack
export interface PackService {
  id: string;
  name: string;
  description: string;
  price?: number;
  price_type: 'fixed' | 'from' | 'per_unit';
}

// Interface pour un pack
export interface Pack {
  id: string;
  name: string;
  description: string;
  total_price: number;
  payment_facility?: string;
  is_active: boolean;
  services: PackService[]; // Services inclus dans le pack
  created_at: string;
  updated_at: string;
}

class PacksApiService {
  private getAuthHeaders() {
    const token = localStorage.getItem('access_token');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  }


  // Récupérer tous les packs
  async getPacks(isActive?: boolean): Promise<Pack[]> {
    try {
      const params = isActive !== undefined ? { is_active: isActive } : {};
      const response = await api.get('/api/packs/', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des packs:', error);
      throw error;
    }
  }

  // Récupérer un pack spécifique
  async getPack(packId: string): Promise<Pack> {
    try {
      const response = await api.get(`/api/packs/${packId}/`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du pack:', error);
      throw error;
    }
  }

  // Créer un nouveau pack (admin uniquement)
  async createPack(pack: Partial<Pack>): Promise<Pack> {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/packs/`, pack, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création du pack:', error);
      throw error;
    }
  }

  // Mettre à jour un pack (admin uniquement)
  async updatePack(packId: string, pack: Partial<Pack>): Promise<Pack> {
    try {
      const response = await axios.put(`${API_BASE_URL}/api/packs/${packId}/`, pack, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du pack:', error);
      throw error;
    }
  }

  // Supprimer un pack (admin uniquement)
  async deletePack(packId: string): Promise<void> {
    try {
      await axios.delete(`${API_BASE_URL}/api/packs/${packId}/`, {
        headers: this.getAuthHeaders()
      });
    } catch (error) {
      console.error('Erreur lors de la suppression du pack:', error);
      throw error;
    }
  }

  // Activer/désactiver un pack (admin uniquement)
  async togglePackStatus(packId: string): Promise<Pack> {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/packs/${packId}/toggle-status/`, {}, {
        headers: this.getAuthHeaders()
      });
      return response.data.pack;
    } catch (error) {
      console.error('Erreur lors du changement de statut du pack:', error);
      throw error;
    }
  }
}

export const packsApiService = new PacksApiService();
export default packsApiService;
